var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 1.66602H7.49984C3.33317 1.66602 1.6665 3.33268 1.6665 7.49935V12.4993C1.6665 16.666 3.33317 18.3327 7.49984 18.3327",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 8.33301V10.833",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 8.33268H14.9998C12.4998 8.33268 11.6665 7.49935 11.6665 4.99935V1.66602L18.3332 8.33268Z",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.582C17.5 15.707 17 16.707 16.225 17.3987C15.5583 17.9737 14.7 18.332 13.75 18.332C12.85 18.332 12.0167 18.0153 11.375 17.482C10.5333 16.7987 10 15.757 10 14.582C10 13.3987 10.5417 12.3404 11.4083 11.657C12.05 11.1404 12.8667 10.832 13.75 10.832C14.925 10.832 15.9667 11.3654 16.65 12.2071C17.1833 12.8487 17.5 13.682 17.5 14.582Z",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9831 13.4072V14.8156L12.8164 15.5155",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCloud);
export default __webpack_public_path__ + "static/media/document-cloud.a3ddca58bf7694d45f3595e4998e58aa.svg";
export { ForwardRef as ReactComponent };